import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class PublicPinExchangeAPICall extends APICallV4 {
    _method = 'public/pin/exchange';
    _type: Method = 'post';
    _retriesCount = 0;
}
